import type React from "react";
import {memo} from "react";

import {HStack} from "../../../components/ui/hstack";
import type {IToastProps} from "../../../components/ui/toast";
import {Toast, ToastIcon, ToastTitle} from "../../../components/ui/toast";

export interface ToastAlertProps {
    uniqueToastId: string;
    status?: IToastProps["action"];
    title: string;
}

const ToastAlert: React.FC<ToastAlertProps> = ({uniqueToastId, status = "success", title}) => {
    return (
        <Toast action={status} id={uniqueToastId}>
            <HStack className="items-center" space="sm">
                <ToastIcon />
                <ToastTitle>{title}</ToastTitle>
            </HStack>
        </Toast>
    );
};

export default memo(ToastAlert);
